import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import { FaSuitcase } from "react-icons/fa";
import { Dropdown, Modal,Spinner } from "react-bootstrap";

import "./card.css";

import Button from "../button/Button";
import IconButton from "./IconButton";
import { API_URL } from "../../../../api";
import ProfileDetails from "./ProfileDetails";
import UpgradeModal from "../upgradenow/upgradenow";
import * as userAction from "../../../../actions/user";
import { useCookies } from "../../../../hooks/useCookies";
import * as messageActon from "../../../../actions/Message";
import { useUserProfile } from "../context/UserProfileContext";
import { useSocket } from "../../../../Context/SockerContext";
import { getProfileMainFullImage } from "../../../../utils/serverUtils";
import { useAppContext } from "../../../../Context/UseContext";
import Loader from "../../../Utility/Loader";

/**
 * @typedef {Object} Profile
 * @property {number} id - The unique identifier for the user.
 * @property {number} user_id - The user ID associated with the user.
 * @property {string} first_name - The first name of the user.
 * @property {string} last_name - The last name of the user.
 * @property {string} birthday - The birthday of the user in ISO format.
 * @property {string} hash - A hash string associated with the user.
 * @property {string} extension - The file extension of the user's profile picture.
 * @property {number} type - The type of user.
 * @property {number} location_id - The location ID associated with the user.
 * @property {string} created_at - The creation timestamp of the user record in ISO format.
 * @property {number} job_id - The job ID associated with the user.
 * @property {string} country - The country of the user.
 * @property {string} continent - The continent of the user.
 * @property {string} location_string - The location string of the user.
 * @property {string} job - The job of the user.
 * @property {boolean} like - The like status of the user.
 *
 * @property {Profile[]} profiles - The profiles of the user.
 * @property {React.Dispatch<React.SetStateAction<Profile[]>>} setProfiles - The setProfiles function to update the profiles.
 */

/**
 * Card component to display user information.
 *
 * @param {Profile} props - The properties passed to the component.
 * @returns {JSX.Element} The Card component.
 */
export default function Card({ show, likes = false, ...props }) {
  const navigate = useNavigate();
  const image = getProfileMainFullImage(props);

  const cookies = useCookies();
  const cardRef = useRef(null);
  const pathname = window.location.pathname;
  const [liked, setLiked] = useState(props.like);
  const { profiles, setProfiles } = useUserProfile();
  const { setPage } = props;
  const [showDropdown, setShowDropdown] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showSkip, setShowSkip] = useState(true);
  const [showHeart, setShowHeart] = useState(true);
  const { socket } = useSocket();
  const [topNavVisible, setTopNavVisible] = useState(true);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const fetchedData = useRef(false);
  const location = useLocation();
  const { isPremium } = useAppContext();
  const allowRedirectRef = useRef(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [skipLoader,setSkipLoader] = useState(false)
  const [likeLoader,setLikeLoader] = useState(false)
  const [chatLoader,setChatLoader] = useState(false)


  useEffect(() => {
    allowRedirectRef.current = true;
  }, [props.user_id]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    function onNewMatch() {
      allowRedirectRef.current = false;
    }

    window.addEventListener("newMatchReceived", onNewMatch);
    return () => {
      window.removeEventListener("newMatchReceived", onNewMatch);
    };
  }, []);

const Countswipe = (actionType) => {
  const currentCount = parseInt(cookies.getCookie("swipeCount")) || 0;

  if (currentCount >= 10) {
    cookies.setCookie("swipeCount", 0, 1);

    // Only show upgrade modal for actions other than skip/like
    if (actionType !== "skip" && actionType !== "like") {
      setShowUpgradeModal(true);
    }
  } else {
    const newCount = currentCount + 1;
    cookies.setCookie("swipeCount", newCount, 1);
  }
};


  const fetchData = async () => {
    if (fetchedData.current || !props.user_id) return;
    fetchedData.current = true;

    try {
      const bottomNav = document.querySelector("#bottomOptions");

      if (bottomNav) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            setTopNavVisible(entry.isIntersecting);
          });
        });

        observer.observe(bottomNav);
      }
      const [checkMatchResponse, checkLikedResponse] = await Promise.all([
        await userAction.getMatchSkipped(props.user_id),
        await userAction.getMatchLike(props.user_id),
      ]);

      const checkSkippedData = await checkMatchResponse;
      const checkLikedData = await checkLikedResponse;

      await setShowSkip(!checkSkippedData.isSkipped);
      await setShowHeart(!checkLikedData.liked);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleRefetch = () => {
        fetchData();
      };

      window.addEventListener("refetchProfiles", handleRefetch);

      return () => {
        window.removeEventListener("refetchProfiles", handleRefetch);
      };
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [props.user_id]);

  async function getRoom() {
    if (isPremium === true) {
      let body = JSON.stringify({
        participantId: props.user_id,
      });
      const response = await messageActon.createChatRoom(body);
      if (response) {
        if (sessionStorage.getItem("conversationId")) {
          socket?.emit("leave-room", sessionStorage.getItem("conversationId"));
        }
        sessionStorage.setItem("conversationId", response.conversationId);
        navigate(`/user/chat/with/${props.first_name}/${props.user_id}`, {
          state: {
            img: image,
            name: props.first_name,
            recepientId: props.user_id,
          },
        });
      }
    } else {
      try {
        // Check if the user is in the matches list
        const checkMatchData = await messageActon.getMatchListById(props.user_id);
        if (!checkMatchData.isMatch) {
          setShowUpgradeModal(true);
          return;
        }
        const response = await messageActon.createChatRoom({
          participantId: props.user_id,
        });
        if (response) {
          if (sessionStorage.getItem("conversationId")) {
            socket?.emit("leave-room", sessionStorage.getItem("conversationId"));
          }
          sessionStorage.setItem("conversationId", response.conversationId);
          navigate(`/user/chat/with/${props.first_name}/${props.user_id}`, {
            state: {
              img: image,
              name: props.first_name,
              recepientId: props.user_id,
            },
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

async function handleIconButtonClick(type) {
  if (isButtonDisabled) return;
  setIsButtonDisabled(true);

  type === "skip" && setSkipLoader(true);
  type === "like" && setLikeLoader(true);
  type === "chat" && setChatLoader(true);

  try {
    // Show upgrade modal for chat or undo if user is not premium
    if ((type === "chat" || type === "undo") && isPremium !== true) {
      setShowUpgradeModal(true);
      return;
    }

    // Chat logic (only for premium users)
    if (type === "chat") {
      await getRoom();
      return;
    }

    const response = await fetch(`${API_URL}customer/matches/${type}`, {
      method: "POST",
      body: JSON.stringify({ personId: props.user_id }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${cookies.getCookie("token")}`,
      },
    });

    const data = await response.json();

    if (response.ok) {

      // Undo logic
      if (type === "undo") {
        const undoUser = data.user;
        const currentProfileIdx = profiles.findIndex(
          (profile) => profile.user_id === props.user_id
        );
          setProfiles([
            ...profiles.slice(0, currentProfileIdx),
            undoUser,
            ...profiles.slice(currentProfileIdx),
          ]);
        return;
      }

      // Skip or Like logic
      if (type === "skip" || type === "like") {

        if (isPremium !== true) {
          Countswipe(type);
        }

        if (
          isPremium !== true &&
          parseInt(cookies.getCookie("swipeCount")) >= 10
        ) {
          Countswipe(type);
          return;
        }

        cardRef.current.scrollIntoView({ behavior: "smooth" });

        if (
          !window.location.pathname.endsWith(props.user_id) &&
          profiles?.length === 1
        ) {
          setPage((prev) => prev + 1);
        }

        if (!window.location.pathname.endsWith(props.user_id)) {
          cardRef.current.style.transform = "translateX(-100%)";
          cardRef.current.style.transition = "transform 0.25s ease-in-out";
          setProfiles(
            profiles.filter((profile) => profile.user_id !== props.user_id)
          );
        }

        if (
          window.location.pathname.endsWith(props.user_id) &&
          type === "skip"
        ) {
          if (
            isPremium !== true &&
            parseInt(cookies.getCookie("swipeCount")) >= 10
          ) {
            Countswipe(type);
            return;
          }
          navigate("/user/home");
        }

        if (allowRedirectRef.current) {
          if (
            window.location.pathname.endsWith(props.user_id) &&
            type === "like"
          ) {
            setTimeout(() => {
              navigate("/user/chat/likes/sent");
            }, 1000);
          }
        }
      }
    }
  } catch (error) {
    console.error("Error handling button click:", error);
  } finally {
    type === "skip" && setSkipLoader(false);
    type === "like" && setLikeLoader(false);
    type === "chat" && setChatLoader(false);

    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 1000);  // Small delay to prevent double-clicks
  }
}


  return (
    <>
      {loading && <Loader />}
      <UpgradeModal show={showUpgradeModal} setShow={setShowUpgradeModal} />
      <ReportModal
        show={showReportModal}
        setShow={setShowReportModal}
        personId={props.user_id}
      />
      <BlockModal
        show={showBlockModal}
        setShow={setShowBlockModal}
        personId={props.user_id}
      />
      {!loading && (
        <div className="card-and-details-container">
          <div
            ref={cardRef}
            className={`card-container ${show ? "show" : ""}`}
            style={{
              backgroundImage: `linear-gradient(0.05deg, #000000 -1.48%, rgba(0, 0, 0, 0.1) 29.79%, rgba(0, 0, 0, 0) 99.96%), url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="details-container" style={{ width: "100%" }}>
              <div
                className="details"
                style={{ marginLeft: "1rem", marginBottom: "1rem" }}
              >
                <p style={{ marginBottom: "-10px" }}>
                  {" "}
                  <span
                    style={{
                      fontSize: "32px",
                      fontWeight: "600",
                      lineHeight: "48px",
                    }}
                  >{`${props.first_name}`}</span>
                  ,{" "}
                  <span
                    style={{
                      fontSize: "32px",
                      fontWeight: "300",
                      lineHeight: "48px",
                    }}
                  >
                    {dayjs().diff(props.birthday, "y")}
                  </span>
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "0.5rem",
                    marginBottom: "-10px",
                  }}
                >
                  <FaSuitcase size={25} />
                  <p
                    style={{
                      fontSize: "medium",
                    }}
                  >
                    {props.job}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "0.5rem",
                  }}
                >
                  <FaLocationDot size={25} />
                  <p
                    style={{
                      fontSize: "medium",
                    }}
                  >
                    {props.location_string
                      ? `${props.location_string}, ${props.country}`
                      : `${props.country}`}
                  </p>
                </div>
              </div>
              {pathname !== "/preview" && (
                <div className={"button-container"}>
                  <div className="left-buttons">
                    <>
                      {chatLoader ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                          className="mt-2"
                        />
                      ) : (
                        <IconButton
                          disabled={isButtonDisabled}
                          type="chat"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleIconButtonClick("chat");
                          }}
                        />
                      )}
                    </>
                  </div>
                  <div className="right-buttons">
                    {showHeart && (
                      <>
                        {likeLoader ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                            className="mt-2"
                          />
                        ) : (
                          <IconButton
                            disabled={isButtonDisabled}
                            type={"likeActive"}
                            onClick={(e) => {
                              e.stopPropagation();
                              setLiked(!liked);
                              handleIconButtonClick("like");
                            }}
                          />
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div
              className="menu"
              style={{
                flexDirection: "row !important",
                justifyContent: "space-between",
                width: `${location.pathname !== "/user/home" ? "93%" : ""}`,
              }}
            >
              {location.pathname !== "/user/home" && (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    window.history.back();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 12L20 12M4 12L10 6M4 12L10 18"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}

              <Dropdown
                className="discovery-profile-preferences-dropdown"
                show={showDropdown}
                onToggle={() => setShowDropdown(!showDropdown)}
                onMouseEnter={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/user/preferences");
                }}
                style={{
                  cursor: "pointer",
                }}
              >
                <Dropdown.Toggle as="div">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 5L10 5M10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5M14 5L20 5M4 12H16M16 12C16 13.1046 16.8954 14 18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12ZM8 19H20M8 19C8 17.8954 7.10457 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21C7.10457 21 8 20.1046 8 19Z"
                      stroke="#FFFFFF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                    border: "none",
                  }}
                >
                  <Dropdown.Item
                    as="button"
                    className="dropdown-hover-button"
                    style={{
                      color: "white",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/user/preferences");
                    }}
                  >
                    Preferences
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div>
            <ProfileDetails
              userId={props.user_id}
              handleIconButtonClick={handleIconButtonClick}
              liked={liked}
              setLiked={setLiked}
              activeTabs={"card"}
              showSkip={showSkip}
              showHeart={showHeart}
              skipLoader={skipLoader}
              likeLoader={likeLoader}
              chatLoader={chatLoader}
            />
          </div>
        </div>
      )}
    </>
  );
}

function ReportModal({ show, setShow, personId }) {
  const cookies = useCookies();
  const [options, setOptions] = useState([]);
  const formRef = useRef(null);
  const fetchedReasons = useRef(false);

  useEffect(() => {
    if (!fetchedReasons.current) {
      fetchedReasons.current = true;
      (async () => {
        try {
          const response = await fetch(
            `${API_URL}customer/matches/report-reasons`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${cookies.getCookie("token")}`,
              },
            }
          );

          if (!response.ok) throw new Error("Failed to fetch report reasons");

          const data = await response.json();
          setOptions(data);
        } catch (error) {
          console.error("Error fetching report reasons:", error);
        }
      })();
    }
  }, [personId]);

  async function report(e) {
    e.preventDefault();
    const response = await fetch(`${API_URL}customer/matches/report`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${cookies.getCookie("token")}`,
      },
      body: JSON.stringify({
        personId: personId,
        ...Object.fromEntries(new FormData(formRef.current)),
      }),
    });
    if (response.ok) {
      window.location.reload();
    }
  }

  return (
    <Modal
      className="customer-modal-without-header-footer"
      size="sm"
      centered
      show={show}
    >
      <Modal.Body>
        <p
          style={{
            fontSize: "large",
            fontWeight: "600",
            margin: "0",
            marginBottom: "1rem",
            color: "#6c6c6c",
          }}
        >
          Report user?
        </p>
        <p
          style={{
            fontSize: "14px",
            margin: "0",
            textAlign: "center",
            color: "#6c6c6c",
          }}
        >
          Report this user for violating MTD's community guidelines. Please
          select a reason for reporting the user below to help us improve your
          experience.
        </p>
        <form
          ref={formRef}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginBlock: "1rem",
          }}
          onSubmit={report}
        >
          {options.map(option => (
            <label
              key={option.id}
              htmlFor={option.id}
              style={{
                display: "flex",
                gap: "1rem",
                alignItems: "center",
                justifyContent: "flex-start",
                fontSize: "14px",
                textAlign: "left",
                color: "#6c6c6c",
              }}
            >
              <input
                type="radio"
                name="reportId"
                id={option.id}
                value={option.id}
                style={{
                  accentColor: "#4E1173",
                  width: "20px",
                  height: "20px",
                }}
              />
              <span>{option.name}</span>
            </label>
          ))}
        </form>
        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            gap: "1rem",
            marginInline: "auto",
          }}
        >
          <button
            type="button"
            style={{
              borderRadius: "9999px",
              padding: "0.75rem 1.5rem",
              border: "2px solid #6c6c6c",
              color: "#6c6c6c",
              backgroundColor: "transparent",
            }}
            onClick={() => setShow(false)}
          >
            Close
          </button>
          <Button
            type="submit"
            style={{
              borderRadius: "9999px",
              padding: "0.75rem 1.5rem",
            }}
            onClick={() => formRef.current?.requestSubmit()}
          >
            Submit
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function BlockModal({ show, setShow, personId }) {
  const cookies = useCookies();

  async function block() {
    const response = await fetch(`${API_URL}customer/matches/block`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${cookies.getCookie("token")}`,
      },
      body: JSON.stringify({
        personId: personId,
      }),
    });
    if (response.ok) {
      window.location.reload();
    }
  }

  return (
    <Modal size="sm" centered show={show}>
      <Modal.Body>
        <p
          style={{
            fontSize: "large",
            fontWeight: "600",
            margin: "0",
            marginBottom: "1rem",
            color: "#6c6c6c",
          }}
        >
          Block user
        </p>
        <p
          style={{
            fontSize: "14px",
            margin: "0",
            textAlign: "center",
            color: "#6c6c6c",
          }}
        >
          Blocked members will no longer be able to message you and won't show
          up when you're browsing
        </p>
        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            gap: "1rem",
            marginInline: "auto",
          }}
        >
          <button
            type="button"
            style={{
              borderRadius: "9999px",
              padding: "0.75rem 1.5rem",
              border: "2px solid #6c6c6c",
              color: "#6c6c6c",
              backgroundColor: "transparent",
            }}
            onClick={() => setShow(false)}
          >
            Close
          </button>
          <Button
            onClick={block}
            style={{
              borderRadius: "9999px",
              padding: "0.75rem 1.5rem",
            }}
          >
            Submit
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export function ChatReqeustRejected({ chatshow, setChatshow }) {
  return (
    <Modal
      centered
      className="customer-modal-without-header-footer selfie-modal"
      show={chatshow}
      onHide={() => setChatshow(false)}
    >
      <Modal.Body
        className="selfie-modal-body"
        style={{
          gap: "0px",
        }}
      >
        You can only chat with person who have matched with you.
        <div style={{ marginTop: "65px" }}>
          <button
            type="submit"
            className="global-save-button"
            onClick={() => setChatshow(false)}
          >
            Okay
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
